import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import gql from 'graphql-tag';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { cliente_proveedor } from 'src/app/shared/object/cliente_proveedor.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import * as _ from 'lodash';
import { bloqueo_historico } from 'src/app/shared/object/bloqueo_historico.model';
import { FormDatosPersonalesComponent } from '../form-datos-personales/form-datos-personales.component';
import { ClientesService } from 'src/app/services/clientes.service';
import { MANTENEDOR_CLIENTES_MODULO, OP_EDICION_DATOS_PERSONALES } from '../cliente-mantenedor.constants';

@Component({
  selector: 'app-mantenedor-clientes-modal-datos-personales',
  templateUrl: './modal-datos-personales.component.html',
  styleUrls: ['../clientes.component.scss'],
  providers: [SecurityService, ValidadoresService],
})
export class MantenedorClientesModalDatosPersonalesComponent implements OnInit {
  // Outputs
  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>();

  @Input() optionsTipoCliente: Array<any> = [];
  @Input() optionsCanal: Array<any> = [];

  public listaBloqueoHistorico: bloqueo_historico[];

  private client: GraphQLClient = null;

  // Modales
  @ViewChild('datosEditarPersonales', { static: true }) datosPersonalesModal: ModalDirective;
  @ViewChild('bloquearDesbloquear', { static: true }) bloqueoModal: ModalDirective;
  @ViewChild('historial', { static: true }) historialModal: ModalDirective;
  @ViewChild(FormDatosPersonalesComponent, { static: true }) formDatosPersonales: FormDatosPersonalesComponent;

  // Forms
  public formAgregaBloqueo: FormGroup;

  // Data & Tmp
  public rutEmpresa: number;
  public sucursalEmpresa: number;
  public codigoModulo: number;
  public rutUsuario: number;

  public paginaActualBloqueo: number;
  public totalRegistrosBloqueo: number;
  public totalPaginasBloqueo: number;

  // Utils
  private log: any;

  public itemCliente: cliente_proveedor;

  public puedeEditarSeccion = false;

  constructor(
    client: GraphQLClient,
    private clientesService: ClientesService,
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    public validadores: ValidadoresService,
    public rutService: RutService,
    public toastService: ToastService,
    private messageRendererService: MessageRendererService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService
  ) {
    this.log = this.clog.log('MODAL-DATOS-PERSONALES');
    this.client = client;
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());
    this.codigoModulo = 1;
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario());

    this.paginaActualBloqueo = 1;
    this.totalPaginasBloqueo = 1;
    this.totalRegistrosBloqueo = 0;

    this.createForms();
  }
  createForms() {
    this.formAgregaBloqueo = new FormGroup({
      motivo: new FormControl({ value: '' }, [Validators.minLength(7), Validators.maxLength(500), Validators.required]),
      esBloqueo: new FormControl(true),
    });
  }

  loadAndShow(cliente: cliente_proveedor) {
    this.formDatosPersonales.loadAndShow(cliente, () => {
      this.datosPersonalesModal.show();
      this.aplicarPermisoEdicionPersonales();
    });
  }

  private aplicarPermisoEdicionPersonales() {
    const self = this;
    this.clientesService.rolOperacionPermitida(
      {
        rut_usu: self.rutUsuario,
        codgo_modulo: MANTENEDOR_CLIENTES_MODULO,
        cod_operacion: OP_EDICION_DATOS_PERSONALES,
      },
      ({ mensajes }) => {
        self.puedeEditarSeccion =
          mensajes && mensajes.length > 0 && mensajes[0].tipo === TipoMensaje.SUCCESS;
        self.formDatosPersonales.setModoSoloLectura(!self.puedeEditarSeccion);
      }
    );
  }

  editarDatosPersonales() {
    const self = this;
    this.clientesService.rolOperacionPermitida(
      {
        rut_usu: self.rutUsuario,
        codgo_modulo: MANTENEDOR_CLIENTES_MODULO,
        cod_operacion: OP_EDICION_DATOS_PERSONALES,
      },
      ({ mensajes }) => {
        if (!mensajes || mensajes.length === 0 || mensajes[0].tipo !== TipoMensaje.SUCCESS) {
          self.messageRendererService.showErrors(mensajes);
          return;
        }
        self.ejecutarGuardarPersonales();
      }
    );
  }

  private ejecutarGuardarPersonales() {
    const valid = this.formDatosPersonales.validate();
    if (!valid) {
      this.toastService.error('Complete datos personales');
      return;
    }

    const formData = this.formDatosPersonales.getFormData();

    let cliente: cliente_proveedor;

    delete formData.datosCliente.tipo_cobro_nombre;
    delete formData.datosCliente.estado_direccion;
    delete formData.datosCliente.tipo_cobro_glosa;
    delete formData.datosCliente.tipo_cliente_glosa;

    cliente = formData.datosCliente;
    this.itemCliente = cliente;
    this.itemCliente.rut = Number(this.validadores._desenmascaraRutyQuitaDV(formData.rutCliente));
    this.itemCliente.razon_social = formData.nombreCliente;
    this.itemCliente.activo = formData.estadoCliente;
    this.itemCliente.bloqueado = formData.esClienteBloqueado;
    this.itemCliente.tipo_cliente_codigo = formData.tipoCliente;
    this.itemCliente.empresa_rut = this.rutEmpresa;
    this.itemCliente.es_cliente = true;
    this.itemCliente.fax = '';
    this.itemCliente.fecha_actualizacion = new Date();
    this.itemCliente.rut_usuario_actualiza = this.rutUsuario;
    this.itemCliente.telefono_principal = null;
    this.itemCliente.telefono_secundario = null;
    this.itemCliente.codigoModulo = this.codigoModulo;
    this.itemCliente.moduloGrabacion = 1;

    delete this.itemCliente['__typename'];
    delete this.itemCliente.nombreprovincia;
    delete this.itemCliente.nombrecomuna;
    delete this.itemCliente['rutFormato'];

    this.postClienteDatosPersonales(this.itemCliente);
  }

  private postClienteDatosPersonales(clienteIngresado: cliente_proveedor) {
    const self = this;
    const bodyx = clienteIngresado;

    this.client.mutate(
      {
        mutation: gql`
          mutation ($entidad: cliente_proveedorInputType) {
            cliente_proveedor {
              guardar(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  rut
                  nombre
                }
              }
            }
          }
        `,
        variables: {
          entidad: bodyx,
        },
      },
      function (respuesta) {
        if (respuesta.data.cliente_proveedor.guardar.respuesta != null) {
          // alert('Registro grabado');
          self.toastService.success('Registro grabado');
          self.onSuccess.emit();
          self.datosPersonalesModal.hide();
        } else {
          // alert(respuesta.data.cliente_proveedor.guardar.mensajes[0].texto);
          self.messageRendererService.showErrors(respuesta.data.cliente_proveedor.guardar.mensajes);
        }
        // setTimeout(() => self.filtraGrillaVistaPrincipal(), 1000);
      }
    );
  }

  showModalBloqueo() {
    const self = this;
    const codigoOperacion = 6;

    const formData = this.formDatosPersonales.getFormData();

    this.client.query(
      {
        query: gql`
          query ($rut_usu: Decimal, $codgo_modulo: Decimal, $cod_operacion: Decimal) {
            rol_operacion {
              operacionPermitida(rut_usu: $rut_usu, codgo_modulo: $codgo_modulo, cod_operacion: $cod_operacion) {
                mensajes {
                  texto
                  tipo
                }
                respuesta
              }
            }
          }
        `,
        variables: {
          rut_usu: self.rutUsuario,
          codgo_modulo: self.codigoModulo,
          cod_operacion: codigoOperacion,
        },
        fetchPolicy: 'no-cache',
      },
      function (respuesta) {
        const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
        if (notificacion.mensajes[0].tipo === TipoMensaje.SUCCESS) {
          const bloqueo = formData.esClienteBloqueado;
          self.formAgregaBloqueo.markAsUntouched();
          self.formAgregaBloqueo.markAsPristine();
          self.formAgregaBloqueo.get('motivo').setValue('');
          if (bloqueo) {
            self.formAgregaBloqueo.get('esBloqueo').setValue(false);
          } else {
            self.formAgregaBloqueo.get('esBloqueo').setValue(true);
          }

          self.bloqueoModal.show();
        } else {
          // alert(notificacion.mensajes[0].texto);
          self.messageRendererService.showErrors(notificacion.mensajes);
        }
      }
    );
  }

  agregaBloqueo() {
    const formData = this.formDatosPersonales.getFormData();
    let bloqueo: bloqueo_historico;
    bloqueo = {
      rut_cliente_proveedor: Number(this.validadores._desenmascaraRutyQuitaDV(formData.rutCliente)),
      rut_empresa: this.rutEmpresa,
      rut_usuario: this.rutUsuario,
      motivo: this.formAgregaBloqueo.get('motivo').value,
      fecha_registro: new Date(),
      bloqueo: this.formAgregaBloqueo.get('esBloqueo').value,
    };
    this.postBloqueo(bloqueo);
  }

  postBloqueo(bloqueoIngresado: bloqueo_historico) {
    const self = this;
    const bodyx = bloqueoIngresado;
    this.client.mutate(
      {
        mutation: gql`
          mutation ($entidad: bloqueo_historicoInputType) {
            bloqueo_historico {
              agregar(entidad: $entidad) {
                respuesta {
                  codigo
                  motivo
                  bloqueo
                }
              }
            }
          }
        `,
        variables: {
          entidad: bodyx,
        },
      },
      function (respuesta) {
        if (respuesta.data.bloqueo_historico.agregar.respuesta != null) {
          // alert('Registro grabado');
          self.toastService.success('Registro grabado');
          self.bloqueoModal.hide();
          self.datosPersonalesModal.hide();
          self.formDatosPersonales.setClienteBloqueado(respuesta.data.bloqueo_historico.agregar.respuesta.bloqueo);
        }
        setTimeout(() => self.onSuccess.emit(), 1000);
      }
    );
  }

  showHistorial() {
    this.historialModal.show();
    this.buscaDatosHistorialBloqueo();
  }

  buscaDatosHistorialBloqueo() {
    const self = this;

    const formData = this.formDatosPersonales.getFormData();

    this.client.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $rutClienteProveedor: Decimal, $paginaActual: Int) {
            bloqueo_historico {
              obtenerSegunFiltro(filtro: { exacto: { rut_empresa: $rutEmpresa, rut_cliente_proveedor: $rutClienteProveedor } }, cantidadRegistrosPorPagina: 10, paginaActual: $paginaActual) {
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    rut_cliente_proveedor
                    rut_usuario
                    rut_empresa
                    fecha_registro
                    motivo
                    bloqueo
                    fecha
                    hora
                    nombre_usuario
                    glosabloqueo
                  }
                }
              }
            }
          }
        `,
        variables: {
          rutEmpresa: String(this.rutEmpresa),
          rutClienteProveedor: Number(self.validadores._desenmascaraRutyQuitaDV(formData.rutCliente)),
          paginaActual: this.paginaActualBloqueo,
        },
        fetchPolicy: 'no-cache',
      },
      function (respuesta) {
        self.listaBloqueoHistorico = respuesta.data.bloqueo_historico.obtenerSegunFiltro.respuesta.registros;
        self.totalRegistrosBloqueo = respuesta.data.bloqueo_historico.obtenerSegunFiltro.respuesta.totalRegistros;
        self.totalPaginasBloqueo = respuesta.data.bloqueo_historico.obtenerSegunFiltro.respuesta.totalPaginas;
        if (self.totalPaginasBloqueo === 0) {
          self.totalPaginasBloqueo = 1;
        }
      }
    );
  }

  retrocedePaginaGrillaBloqueo() {
    this.paginaActualBloqueo = this.paginaActualBloqueo - 1;
    this.buscaDatosHistorialBloqueo();
  }

  avanzaPaginaGrillaBloqueo() {
    this.paginaActualBloqueo = this.paginaActualBloqueo + 1;
    this.buscaDatosHistorialBloqueo();
  }
}
